import { apiBookingManager } from "@/services/api-booking-manager";
import { format } from "date-fns";
import { createToast } from "vercel-toast";
import {
  CreateBookingApiParams,
  CreateBookingApiResponse,
} from "./create-booking.types";

export const CreateBookingApi = async (params: CreateBookingApiParams) => {
  try {
    const dataFormatted = {
      private_office_id: params.private_room.id,
      type: 6,
      on_demand: false,
      company_id: params.company.id,
      app_type: 3,
      notes: "",
      bookings: [
        {
          booking_start: format(
            new Date(params.start_date),
            "yyyy-MM-dd HH:mm:ss",
          ),
          months_quantity: Number(params.months),
          users_quantity: 1,
          payout_rate_percentual: Number(params.take),
        },
      ],
    };

    const { data } = await apiBookingManager.post<CreateBookingApiResponse>(
      `/bookings/privateoffice`,
      dataFormatted,
    );

    return {
      data: data,
    };
  } catch (err) {
    createToast(`Erro ao tentar criar um booking ${err}`, {
      type: "error",
      timeout: 2000,
    });

    return {
      data: null,
    };
  }
};
